var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"text-center height-all",attrs:{"align-h":"center","align-v":"center"}},[_c('b-col',{attrs:{"md":"8"}},[_c('pulse-loader',{attrs:{"color":_vm.color,"size":_vm.size}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }